import React from 'react';
import './welcomePrompts.scss';
import { Icons } from '../../../../assets/icons/chatbotIcons';
import dayjs from 'dayjs';

type IconKey = keyof typeof Icons;


interface PromptItem {
  label: string;
  icon: IconKey;
  prompt: string;
}

interface WelcomePromptsProps {
  handlePromptSelect: (promptText: string) => void;
  loggedInUserName: string;
}

const WelcomePrompts:React.FC<WelcomePromptsProps> = ({handlePromptSelect, loggedInUserName = ""}) => {

  const currentMonthYear = dayjs().format('MMMM YYYY');

   const welcomePrompts:any = [
    {
      label: "List my team",
      icon: "doctor",
      prompt: "List my team",
    },
    {
      label: "Who's on-call in the cardiology department?",
      icon: "group",
      prompt: "Who's on-call in the cardiology department?",
    },
    {
      label: "Get my schedule details",
      icon: "emergency",
      prompt: `Get schedule details of ${loggedInUserName} for ${currentMonthYear}`,
    },
  ];

  
  return (
    <div className="welcome-prompts-container">
      <div className="welcome-header">
        <div className="gradient-header">
          <h2>Hi {loggedInUserName}, How Can I Help You Today!</h2>
        </div>
      </div>

     <div className="prompts-list">
     {welcomePrompts.map((item: PromptItem, index: number) => (
          <div className="prompt-item" key={index} onClick={() => handlePromptSelect(item.prompt)}>
            <div className="prompt-icon">
              <img src={Icons[item.icon]} alt={item.label} className="prompt-icon-img" />
            </div>
            <div className="prompt-text">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WelcomePrompts;